<div class="filter-bar-container"
     [style.max-height]="!showingFilterBar ? '0' : '185px'"
>
    <div class="filter-bar-start"
         [style.display]="!showingFilterBar ? 'none' : 'flex'"
         [style.opacity]="!showingFilterBar ? '0' : '1'">
        <div class="filter-bar-label">
          Filter by:
        </div>

        <div class="chip-list"
        >

          <mat-chip-listbox>
            @for (chip of filterChips; track $index) {
              <mat-chip-option
                               [removable]="true"
                               [selectable]="false"
                               (removed)="filterChipRemoved($event, chip)"
                               (click)="filterChipSelected($event, chip)"
              >
                <span>{{ chip.filterName }}:</span>&nbsp;<span>{{ chip.items }}</span>
                @if (!chip.clear) {
                  <button matChipRemove>
                    <mat-icon>cancel</mat-icon>
                  </button>
                }
              </mat-chip-option>
            }
          </mat-chip-listbox>


          <mat-menu #filtersListMenu="matMenu">
            @if (useDateFilter) {
              <button mat-menu-item
                      #matTriggerDateFilter="matMenuTrigger"
                      [matMenuTriggerFor]="dateRangeMenu"
                      [ngClass]="{hidden: !dateFilter || (!!dateFilter && (!!dateFilter.from || !!dateFilter.to))}"
              >
                Date Range
              </button>
            }
            @if (useVehicleGroupFilter) {
              <button mat-menu-item
                      #matTriggerVehicleGroup="matMenuTrigger"
                      [matMenuTriggerFor]="vehicleGroupMenu"
                      [ngClass]="{hidden: !!vehicleGroupFilter}"
              >
                Vehicle Group
              </button>
            }
            @if (useVehicleFilter) {
              <button mat-menu-item
                      #matTriggerVehicle="matMenuTrigger"
                      [matMenuTriggerFor]="vehicleMenu"
                      [ngClass]="{hidden: !!vehicleFilter}"
              >
                Vehicle
              </button>
            }
            @if (useDriverFilter) {
              <button mat-menu-item
                      #matTriggerDriver="matMenuTrigger"
                      [matMenuTriggerFor]="driverMenu"
                      [ngClass]="{hidden: !!driverFilter}"
              >
                Driver
              </button>
            }
            @if (useUserFilter) {
              <button mat-menu-item
                      #matTriggerUser="matMenuTrigger"
                      [matMenuTriggerFor]="userMenu"
                      [ngClass]="{hidden: !!userFilter}"
              >
                Driver
              </button>
            }
            @if (useObservationTypeGroupFilter) {
              <button mat-menu-item
                      #matTriggerObservationTypeGroup="matMenuTrigger"
                      [matMenuTriggerFor]="observationTypeGroupMenu"
                      [ngClass]="{hidden: !!observationTypeGroupFilter}"
              >
                Observation Group
              </button>
            }
            @if (useAssetStatusFilter) {
              <button mat-menu-item
                      #matTriggerAssetStatus="matMenuTrigger"
                      [matMenuTriggerFor]="statusMenu"
                      [ngClass]="{hidden: !!assetStatusFilter}"
              >
                Status
              </button>
            }
            @if (useRouteAssignmentStatusFilter) {
              <button mat-menu-item
                      #matTriggerRouteAssignmentStatus="matMenuTrigger"
                      [matMenuTriggerFor]="routeAssignmentStatusMenu"
                      [ngClass]="{hidden: !!routeAssignmentStatusFilter}"
              >
                Route Assignment Status
              </button>
            }
            @if (usePassFailFilter) {
              <button mat-menu-item
                      #matTriggerPassFail="matMenuTrigger"
                      [matMenuTriggerFor]="passFailMenu"
                      [ngClass]="{hidden: !!passFailFilter}"
              >
                Pass/Fail
              </button>
            }
          </mat-menu>

            <mat-menu #dateRangeMenu="matMenu" [hasBackdrop]="false">
                <app-date-filter-dropdown
                        [origin]="origin"
                        [defaultValue]="defaultDateFilter"
                        (filterChanged)="onDateFilterChanged($event)"
                >
                </app-date-filter-dropdown>
            </mat-menu>

            <mat-menu #vehicleGroupMenu="matMenu">
                <app-vehicle-group-filter
                  [origin]="origin"
                  (filterChanged)="onVehicleGroupsChanged($event)"
                ></app-vehicle-group-filter>
            </mat-menu>

            <mat-menu #vehicleMenu="matMenu">
                <app-vehicle-filter
                  [origin]="origin"
                  (filterChanged)="onVehicleChanged($event)"
                ></app-vehicle-filter>
            </mat-menu>

            <mat-menu #driverMenu="matMenu">
                <app-driver-filter
                  [origin]="origin"
                  (filterChanged)="onDriverChanged($event)"
                ></app-driver-filter>
            </mat-menu>

            <mat-menu #userMenu="matMenu">
              <app-user-filter
                [origin]="origin"
                (filterChanged)="onUserChanged($event)"
              ></app-user-filter>
            </mat-menu>

            <mat-menu #observationTypeGroupMenu="matMenu">
                <app-observation-group-filter
                        [origin]="origin"
                        (filterChanged)="onObservationTypeGroupFilterChanged($event)"
                ></app-observation-group-filter>
            </mat-menu>

            <mat-menu #statusMenu="matMenu">
                <app-asset-status-filter
                        [origin]="origin"
                        (filterChanged)="onAssetStatusFilterChanged($event)"
                ></app-asset-status-filter>
            </mat-menu>

            <mat-menu #routeAssignmentStatusMenu="matMenu">
                <app-route-assignment-status-filter
                        [origin]="origin"
                        (filterChanged)="onRouteAssignmentStatusFilterChanged($event)"
                >
                </app-route-assignment-status-filter>
            </mat-menu>

            <mat-menu #passFailMenu="matMenu">
              <app-pass-fail-filter
                [origin]="origin"
                (filterChanged)="onPassFailFilterChanged($event)"
              ></app-pass-fail-filter>
            </mat-menu>
        </div>
    </div>
</div>
